import React from 'react'
import { browserLogger } from 'src/utils/browser-logger'
import { useAuthData } from 'src/components/auth/util'

export const UserBack: React.FC = () => {
  const authData = useAuthData()

  const userbackDisplay = () => {
    const userback = (window as any).Userback
    const btn: HTMLElement | null = document.querySelector('#userback_button_container .userback-button-se')
    if (btn) {
      btn.style.display = 'block'
    }
    userback.show()
  }

  React.useEffect(() => {
    try {
      if (!authData) {
        return
      }
      const userback = (window as any).Userback || {
        init: () => {
          browserLogger.debug('userback not loaded')
        },
      }
      userback.init('30573|45380|pYTzz0GSdbEVk9kWXHhJg4n8v', {
        email: authData.email,
        on_load: () => {
          userback.setData({
            id: authData.id,
            role: authData.role,
          })
          userbackDisplay()
        },
      })
    } catch (error) {
      browserLogger.error('error initializing userback', { error })
    }
  }, [Boolean(authData?.email)])

  return null
}
